import React from "react";
import MaxContent from "../../layout/MaxContent";
import { StrapiImage } from "../Types";
import { fixStrapiUrl } from "../../helpers/strapiUrl";

interface StrapiData {
  data: {
    IconsList: IconType[];
  };
}

type IconType = {
  SingleImage: StrapiImage;
  ImageURL?: string;
  AlternativeText?: string;
};

const IconsRow: React.FC<StrapiData> = ({ data }) => {
  return (
    //cs changed flex to grid so that its either 6 in row or two rows of three bug250
    <MaxContent size="full">
      <div className="bg-skyblue py-[30px] mx-auto w-full">
        <MaxContent size="content">
          <div className="flex justify-center items-center gap-5 flex-wrap">
           
              {data.IconsList?.map((icon: any, index: number) => {
                const strapiUrl = icon?.SingleImage?.url ? fixStrapiUrl(icon.SingleImage.url) : null;
                const imageUrl = strapiUrl || icon?.ImageURL;
                const altText = icon?.SingleImage?.alternativeText || icon?.AlternativeText || "";

                if (!imageUrl) return null;

                return (
                  <img
                    loading="lazy"
                    src={imageUrl}
                    className=" w-[100px] sm:w-auto h-auto"
                    key={"icon" + index}
                    alt={altText}
                  />
                );
              })}
        
          </div>
        </MaxContent>
      </div>
    </MaxContent>
  );
};

export default IconsRow;
